const ReturnPolicy = () => {
  return (
    <div className="max-w-5xl mx-auto py-16 px-6">
      <h1 className="text-3xl font-bold mb-6">
        Return Policy
      </h1>

      <p className="text-gray-700 text-lg leading-8">
        Replacement products will be delivered within 5–7 business days.
      </p>
    </div>
  );
};

export default ReturnPolicy;